<template>
  <div>
    <Row v-for="(item, index) in orderTrail" :key="index" style="marginTop:15px">
      <Col span="6">
        {{item.createdAt}}
      </Col>
      <Col span="8">
        <p>{{item.name}}</p>
        <p v-html="item.content"></p>
        <p>{{item.remark}}</p>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: ['orderTrail'],
  data() {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/operate-detail.vue